import { createAction, props } from "@ngrx/store";
import { ISimulationClass } from "../../../interfaces/simulation/simulation-class/ISimulationClass";

export const loadSimulationClasses = createAction(
    '[Simulation] Load All Simulation Classes',
);

export const loadSimulationClassesSuccess = createAction(
    '[Simulation] Load All Simulation Classes Success',
    props<{ simulationClasses: ISimulationClass[] }>()
);

export const loadSimulationClassesError = createAction(
    '[Simulation] Load All Simulation Classes Error',
    props<{ error: any }>()
);
